import {
    BarLine,
    ButtonContainer,
    Container,
    InputWrap,
    TotalResultText,
} from '../users/style';
import {
    Counter,
    CsvDownloader,
    Loader,
    PdfDownloader,
    DeleteModal,
    SelectComp,
} from '../../common/component';
import { Grid, Header } from '../dashboard/styles';
import { TableCompData } from '../../common/component/table';
import { IssuerRequestTableHeader } from '../../common/utils/dataUtils';
import { BsEye } from 'react-icons/bs';
import { AiOutlineDelete } from 'react-icons/ai';
import { ContainerComp } from '../../common/component/Ui/containerComp';
import { Col, FormControl } from 'react-bootstrap';
import SearchIcon from '../../common/images/search_icon.svg';
import { ReactComponent as SupportIcon } from '../../common/images/support_icon.svg';
import {
    useIssuerRequestStatsQuery,
    useDeleteIssuerRequestMutation,
    useGetAllIssuerRequestQuery,
} from '../../store/isssuerRequestApi';
import { useEffect, useState } from 'react';
import { IContactUs } from '../../store/contactUsApi/interface';
import { showErrorToast, showSuccessToast } from '../../common/utils/toast';
import { useParams } from 'react-router-dom';
import { IIssuerRequest } from '../../store/isssuerRequestApi/interface';

export const BorrowerRequest = () => {
    const param = useParams();
    const requestId = param?.id as string;
    const [searchTerm, setSearchTerm] = useState('');
    const [dropDownTerm, setDropDownTerm] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [newArray, setNewArray] = useState<IContactUs[] | any>();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(100);

    const paginate = {
        perPage: rowsPerPage,
        currentPage: currentPage,
    };

    const {
        data: allRequests,
        isLoading,
        isFetching,
    } = useGetAllIssuerRequestQuery(paginate, {
        refetchOnMountOrArgChange: true,
    });

    const { data: issuerRequestStats } = useIssuerRequestStatsQuery();

    const [deleteIssuerRequest, { isLoading: isDeleting }] =
        useDeleteIssuerRequestMutation();

    useEffect(() => {
        setTotalRows(allRequests?.pagination?.totalDocumentCount as number);
    }, [allRequests?.pagination?.totalDocumentCount]);
    const handlePageChange = (page: any) => setCurrentPage(page);
    const handleRowsPerPageChange = (newRowsPerPage: any) => {
        if (!allRequests?.data?.length) return; //when the table is rendered for the first time, this would trigger, and we don't need to call fetchUsers again
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const Items = [
        {
            name: ' View more',
            icon: <BsEye size={15} />,
            OnClick: () => {},
            link: 'view',
            id: '_id',
        },
        {
            name: 'Delete item',
            icon: <AiOutlineDelete size={15} />,
            OnClick: (data: any) => {
                setDeleteId(data?._id);
                setShowDeleteModal(true);
            },
        },
    ];

    // To implement search and dropdown input
    useEffect(() => {
        if (searchTerm === '' && dropDownTerm === '') {
            setNewArray(allRequests?.data);
        }
        if (dropDownTerm !== '') {
            let filteredItems = allRequests?.data?.filter(
                (item: IIssuerRequest) => {
                    return item?.requestStatus
                        .toLowerCase()
                        .includes(dropDownTerm.toLowerCase());
                },
            );
            setNewArray(filteredItems);
        }
        if (searchTerm !== '') {
            let searchItems = allRequests?.data?.filter(
                (item: IIssuerRequest) => {
                    return item?.accountName
                        ?.toLowerCase()
                        .includes(searchTerm?.toLowerCase());
                },
            );
            setNewArray(searchItems);
        }
    }, [allRequests, searchTerm, dropDownTerm]);

    const confirmDelete = () => {
        deleteIssuerRequest(deleteId)
            .unwrap()
            .then((result) => {
                showSuccessToast(result?.message);
                setShowDeleteModal(false);
            })
            .catch((error) => {
                showErrorToast(error?.data?.message);
            });
    };

    //add the header like this and just send array of Data to CsvDownloader
    const headersCsv = [
        { label: 'Full Name', key: 'accountName' },
        {
            label: 'Company',
            key: 'companyName',
        },
        {
            label: 'Business Age',
            key: 'businessAge',
        },
        {
            label: 'Bank',
            key: 'bankName',
        },
        {
            label: 'Industry',
            key: 'industryType',
        },
        {
            label: 'Rating',
            key: 'supplierAndVendorRating',
        },
    ];
    //add the header like this and just send array of Data to pDFDownloader
    const headersPdf = [
        { header: 'Full Name', dataKey: 'accountName' },
        {
            header: 'Company',
            dataKey: 'companyName',
        },
        {
            header: 'Business Age',
            dataKey: 'businessAge',
        },
        {
            header: 'Bank',
            dataKey: 'bankName',
        },
        {
            header: 'Industry',
            dataKey: 'industryType',
        },
        {
            header: 'Rating',
            dataKey: 'supplierAndVendorRating',
        },
    ];

    return (
        <Container>
            {isLoading || isDeleting ? <Loader /> : null}
            <Header>Become a Company Request</Header>
            <Grid>
                <Counter
                    counter_title="Total Request"
                    count={issuerRequestStats?.data?.totalApplicants || 0}
                    iconFill="blue"
                    iconBG="blue"
                >
                    <SupportIcon />
                </Counter>

                <Counter
                    counter_title="Approved Request"
                    count={
                        issuerRequestStats?.data?.totalApprovedApplicants || 0
                    }
                    iconFill="green"
                    iconBG="green"
                >
                    <SupportIcon />
                </Counter>
                <Counter
                    counter_title="Pending Request"
                    count={
                        issuerRequestStats?.data?.totalPendingApplicants || 0
                    }
                >
                    <SupportIcon />
                </Counter>
                <Counter
                    counter_title="Rejected Request"
                    count={
                        issuerRequestStats?.data?.totalRejectedApplicants || 0
                    }
                    iconFill="red"
                    iconBG="red"
                >
                    <SupportIcon />
                </Counter>
            </Grid>
            <div className="d-xl-flex align-items-center justify-content-between mt-5 mb-3">
                <Col
                    sm={12}
                    xl={9}
                    className="d-flex flex-column flex-sm-row align-items-center justify-content-between"
                >
                    <Col
                        xs={10}
                        sm={6}
                        className="d-flex align-items-center my-3"
                    >
                        <SelectComp
                            selectText="All Requests"
                            arrayComp={['Approved', 'Rejected', 'Pending']}
                            onChange={(e: any) =>
                                setDropDownTerm(e.target.value)
                            }
                        />
                        <TotalResultText>{`${
                            allRequests?.data?.length || 0
                        } result`}</TotalResultText>
                    </Col>
                    <InputWrap>
                        <img src={SearchIcon} alt="" />
                        <FormControl
                            aria-label="Amount (to the nearest dollar)"
                            placeholder="Search"
                            className="border-start-0 border-bottom-0 border-top-0"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </InputWrap>
                </Col>
                <div className="d-flex align-items-center justify-content-center justify-content-sm-end my-3">
                    <ButtonContainer>
                        <PdfDownloader
                            fileName={'Issuer Request Record'}
                            {...{
                                columns: headersPdf,
                                body: allRequests?.data,
                            }}
                        />
                        <BarLine />
                        <CsvDownloader
                            headers={headersCsv}
                            data={allRequests?.data}
                        />
                    </ButtonContainer>
                </div>
            </div>

            <ContainerComp>
                <TableCompData
                    columns={IssuerRequestTableHeader(Items)}
                    data={newArray}
                    progressPending={isFetching}
                    totalRows={totalRows}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    handlePageChange={handlePageChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                />
            </ContainerComp>
            <DeleteModal
                deleteItem={'Company Request'}
                showDeleteModal={showDeleteModal}
                cancelDelete={() => setShowDeleteModal(false)}
                confirmDelete={confirmDelete}
                isDeleting={isDeleting}
            />
        </Container>
    );
};
